module.exports = __webpack_public_path__ + "img/forgot-password-icon.3ef802a0.svg";